import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { CONTACT_INFO } from "@/data/site";

const Doc = ({ testid, sections }) => (
  <section className="mx-auto max-w-3xl px-5 pb-24 lg:px-8" data-testid={testid}>
    <Reveal>
      <div className="space-y-10">
        {sections.map((s, i) => (
          <div key={i}>
            <h2 className="font-heading text-2xl font-semibold text-white">{s.h}</h2>
            {s.p.map((para, j) => (
              <p key={j} className="mt-3 text-base leading-relaxed text-zinc-400">{para}</p>
            ))}
          </div>
        ))}
        <p className="border-t border-white/10 pt-8 text-sm text-zinc-500">
          Questions? Contact us at <span className="text-brand">{CONTACT_INFO.email}</span>.
        </p>
      </div>
    </Reveal>
  </section>
);

export function Privacy() {
  return (
    <div data-testid="privacy-page">
      <PageHero overline="Legal" titleLines={["Privacy Policy"]} subtitle="How Activity Hub Manager collects, uses and protects your information." />
      <Doc
        testid="privacy-content"
        sections={[
          { h: "1. Information we collect", p: ["We collect information you provide when you register, contact us or use the platform — such as your name, email, institute details and usage data — to deliver and improve our services."] },
          { h: "2. How we use your data", p: ["Your data is used to operate the platform, send reminders and notifications, provide support and improve our features. We never sell your personal information."] },
          { h: "3. Data security", p: ["We apply bank-grade encryption, secure cloud storage and role-based access control. Only authorised members of your institute can access your data."] },
          { h: "4. Your rights", p: ["You may access, correct or delete your data at any time. Contact us and we'll help you exercise your rights promptly."] },
        ]}
      />
    </div>
  );
}

export function Terms() {
  return (
    <div data-testid="terms-page">
      <PageHero overline="Legal" titleLines={["Terms & Conditions"]} subtitle="The terms that govern your use of Activity Hub Manager." />
      <Doc
        testid="terms-content"
        sections={[
          { h: "1. Using our service", p: ["By registering for Activity Hub Manager you agree to use the platform lawfully and to keep your account credentials secure. You are responsible for the activity within your institute's account."] },
          { h: "2. Subscriptions & trials", p: ["Free trials last 14 days. Paid plans renew automatically unless cancelled. You can upgrade, downgrade or cancel at any time from your account settings."] },
          { h: "3. Acceptable use", p: ["You agree not to misuse the platform, attempt unauthorised access, or use it to store unlawful content. We may suspend accounts that violate these terms."] },
          { h: "4. Limitation of liability", p: ["The service is provided 'as is'. To the maximum extent permitted by law, Activity Hub Manager is not liable for indirect or consequential damages arising from use of the platform."] },
        ]}
      />
    </div>
  );
}
